import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Field as HeadlessField } from '@flywire/react-headlessui';
import { cx } from '../../utils';
export const useErrorClasses = ({ className }) => {
    return cx('text-xs font-medium text-red-600', className);
};
const FieldErrorComponent = forwardRef(({ className, ...rest }, ref) => {
    const classes = useErrorClasses({ className });
    return _jsx(HeadlessField.Error, { className: classes, ref: ref, ...rest });
});
FieldErrorComponent.displayName = 'Error';
const FieldError = FieldErrorComponent;
export { FieldError };
//# sourceMappingURL=Error.js.map